import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
// import { Address, blankAddress } from '../../../common/models/address'
import { AddressDB } from '../../../user-management/models/address'
import { FieldValidator } from '../../../validations/field-validator'
import { NotPoBoxAddressTextFieldValidator } from '../../../validations/not-po-box-address-text-field-validator'
import { Validatable } from '../../../validations/validatable'
import { FormValidationService } from '../../../validations/form-validation-service'
// import { State } from '../../../common/models/state'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { StateGateway } from '../../gateways/state-gateway'

@Component({
    selector: 'ConfigurableAddress',
    templateUrl: 'configurable-address-component.html'
})
export class ConfigurableAddressComponent extends Validatable<AddressDB> implements OnInit {
    @Input() disabled: boolean = false
    @Input() states: State[] = [] as State[]
    @Input() allowPOBoxes = true
    @Input() address: AddressDB
    @Input() showZip4: boolean = false

    @Input() addressLinePrefix = ''
    @Input() addressLine1Label = 'Line 1'
    @Input() addressLine2Label = 'Line 2 (optional)'

    @Output() onValueChange: EventEmitter<AddressDB> = new EventEmitter<AddressDB>()

    _address: AddressDB = {} as AddressDB

    notBlankValidator = new NotBlankGenericFieldValidator()
    numericValidator = new NumericTextFieldValidator()
    zipCodeValidator = new LengthTextFieldValidator(5)
    zip4CodeValidator = new LengthTextFieldValidator(4)
    line1Validators: FieldValidator<string>[] = []
    line2Validators: FieldValidator<string>[] = []
    blurnotify: boolean = false
    constructor(formValidationService: FormValidationService, private _stateGateway: StateGateway) {
        super(formValidationService)
    }

    ngOnInit(): void {
        //this.address = {} as AddressDB
        this.line1Validators.push(this.notBlankValidator)
        if (!this.allowPOBoxes) {
            this.line1Validators.push(new NotPoBoxAddressTextFieldValidator())
            this.line2Validators.push(new NotPoBoxAddressTextFieldValidator())
        }
        if (this.addressLinePrefix !== '') {
            this.addressLine1Label = this.addressLinePrefix + ' ' + this.addressLine1Label
            this.addressLine2Label = this.addressLinePrefix + ' ' + this.addressLine2Label
        }
        if (this.states === ([] as State[])) {
            this._stateGateway.getAllStates().subscribe((states: State[]) => (this.states = states))
        }
    }

    updateAddress(fieldName: string, fieldValue: string | State) {
        this.validate()
        if (fieldName === 'state.code') {
            let state: any = this.address['state']
            state.code = fieldValue
            this.address['state'] = state
        } else {
            this.address[fieldName] = fieldValue
        }
        this.onValueChange.emit(this.address)
    }

    onBlur() {
        this.validate()
    }
    getValue(): AddressDB {
        return this.address
    }

    getLabel(): string {
        return ''
    }

    poboxChange(event: any) {
        this.line1Validators = [] as FieldValidator<string>[]
        this.line1Validators.push(this.notBlankValidator)
        if (!event) {
            this.line1Validators.push(new NotPoBoxAddressTextFieldValidator())
            this.line2Validators.push(new NotPoBoxAddressTextFieldValidator())
        }
        this.blurnotify = event

        this.updateAddress('poboxoverride', event)
    }
}
